// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorCampaigns = (client) => ({
    /**
     * `POST /vendor/campaigns`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateCampaign
     * @source packages/modules/b2c-core/src/api/vendor/campaigns/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/campaigns", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/campaigns/:id/promotions`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPostCampaignsIdPromotions
     * @source packages/modules/b2c-core/src/api/vendor/campaigns/[id]/promotions/route.ts
     */
    createPromotion: (id, body, query, headers) => client.fetch(buildPath("/vendor/campaigns/:id/promotions", [id]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/campaigns/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteCampaignById
     * @source packages/modules/b2c-core/src/api/vendor/campaigns/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/vendor/campaigns/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/campaigns`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListCampaigns
     * @source packages/modules/b2c-core/src/api/vendor/campaigns/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/campaigns", { method: "GET", query, headers }),
    /**
     * `GET /vendor/campaigns/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetCampaignById
     * @source packages/modules/b2c-core/src/api/vendor/campaigns/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/campaigns/:id", [id]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/campaigns/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateCampaignById
     * @source packages/modules/b2c-core/src/api/vendor/campaigns/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/vendor/campaigns/:id", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=campaigns.js.map